import React, { useState, useEffect } from "react";
// import { IframeList } from "./IframeList";
import { ButtonList } from "./ButtonList";
import { ComboButton } from "./ComboButton";
import { ResponseMessage } from "./ResponseMessage";
import { ResultTable } from "./ResultTable";
import { ZipButton } from "./ZipButton";
import { QRCodeSVG } from "qrcode.react";
import { SourceMedSourcesList } from "./SourceMedSourcesList";

export const SearchArea = () => {
  let windowURL = window.location.href;
  const isLive = windowURL.includes("haloinfusions.com");
  windowURL = windowURL.split("/"); //break url
  windowURL = windowURL[windowURL.length - 1].split("="); //break end of url to see if it has a search
  const isURLSearch = windowURL[0] === "?search";
  const [searchText, setSearchText] = useState(isURLSearch ? windowURL[1] : "");
  const [name, setName] = useState("name not found");
  const [summaryData, setSummaryData] = useState(null);
  const [multiResults, setMultiResults] = useState(null);
  const [pdfURLS, setPDFUrls] = useState([]);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (isURLSearch) {
      console.log("Calling url search with ", searchText);
      callAT();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function keyPress(event) {
    if (event.keyCode === 13) {
      callAT();
    }
  }

  function callAT() {
    let productID = searchText.trim().toUpperCase();
    setSummaryData(null);
    setPDFUrls([]);

    setStatus("loading");
    if (productID.length > 0) {
      productID = productID.replaceAll("#", "%23");
      let urlFinal = isLive
        ? "https://halo-test-result-server-41e2a62a12d7.herokuapp.com/results/" //"https://results.haloinfusions.com/results/"
        : "http://localhost:3000/results/";
      urlFinal = urlFinal + productID;
      console.log("final url: ");
      console.log(urlFinal);
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", urlFinal, false); // false for synchronous request
      xmlHttp.send(null);
      let result = xmlHttp.responseText;
      setStatus(null);
      if (result === "no test data found") {
        //if no data found
        setStatus("failure");
      } else if (result === "bad request" || !result) {
        //if server reports an error or doesn't respond
        setStatus("badRequest");
      } else {
        //if all seems good
        let tempResult = JSON.parse(result);
        if (tempResult.length > 1) {
          console.log("Many Results");
          let tempOptions = [];
          for (let i = 0; i < tempResult.length; i++) {
            //for each result
            let productName = tempResult[i].name ?? "result " + i; //if no name simply number the product
            tempOptions.push(
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <>
                <button
                  onClick={() => displayResult(tempResult[i])}
                  style={{ cursor: "pointer", color: "white" }}
                >
                  -{productName}
                </button>
                <br />
              </>
            );
          }
          setMultiResults(<ul>{tempOptions}</ul>);
        } else {
          //if only one simply display the result
          console.log("Only one result");
          displayResult(tempResult[0]);
        }
      }
    } else {
      setStatus("empty");
    }
  }

  /**
   * Todo change this so urls array is not a thing. Instead array of buttons. Clicking one changes the selected url to what you want to see.
   * @param {*} resultObject
   */
  function displayResult(resultObject) {
    setMultiResults(null);
    let parsedObject =
      typeof resultObject === "object"
        ? resultObject
        : JSON.parse(resultObject);
    //console.log("Result object to show: ", parsedObject);
    //hideElements(); //when new click hide elements
    const urlArray = parsedObject.urls; //get urls for this
    setName(parsedObject.name);
    //display summary
    let tempSummaryData = {};
    for (let resultName in parsedObject) {
      if (resultName !== "urls") {
        //for each result lets check status and set color and result for summary
        let resultStatus = parsedObject[resultName];
        // element.innerHTML = resultStatus ? resultStatus : "Pending"; //if result status does not exist assume Pending
        tempSummaryData[resultName] = resultStatus;
      }
    }
    //if urls exist add iframes for each
    setPDFUrls(urlArray);
    if (JSON.stringify(tempSummaryData).length > 2 && urlArray.length === 0) {
      //if summary exists but no urls show message pending that
      setStatus("pending");
    }
    setSummaryData(tempSummaryData);
  }
  return (
    <>
      <div style={{ fontSize: "large" }}>Enter Batch ID:</div>
      <button
        type="button"
        onClick={() => callAT()}
        id="search"
        style={{ float: "right", color: "white" }}
      >
        Find Test Results
      </button>
      <div
        style={{
          overflow: "hidden",
          paddingRight: "0.5em",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <input
          style={{
            border: "1px solid #ccc; height: 46px",
            backgroundColor: "rgb(247,204,159)",
          }}
          type="search"
          name="productID"
          id="productID"
          onKeyDown={(event) => keyPress(event)}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <br />
      {multiResults ? (
        <div id="multipleProducts">
          The Batch ID you've searched for has multiple sets of results. Select
          which you'd like to view.
        </div>
      ) : null}
      {multiResults}
      {/*summaryData && (
        <>
          {" "}
          <div>Disposition Date: {summaryData.date?.split("T")[0]}</div>
          <hr />
        </>
      )*/}
      {/*summaryData?.sourceMeds?.length > 0 && (
        <>
          {" "}
          <div>
            {`Source Extract Batch ID${
              summaryData.sourceMeds.includes(",") ? "s" : ""
            }: `}
            {summaryData.sourceMeds.replace(",", ", ")}
          </div>
          <hr />
        </>
      )*/}
      {summaryData?.infoFields && (
        <>
          <h4>Product Information For {summaryData.batchId}</h4>
          {Object.keys(summaryData.infoFields).map((field) => (
            <>
              <div>
                <b>{field}</b>: {summaryData.infoFields[field]}
              </div>
              <hr style={{ margin: "8px" }} />
            </>
          ))}
        </>
      )}{" "}
      <SourceMedSourcesList
        data={summaryData?.distData}
        salesData={summaryData?.salesData}
        mfrDate={summaryData?.date}
        mfr={summaryData?.mfr}
        dstr={summaryData?.dstr}
        licHldr={summaryData?.licHldr}
        license={summaryData?.license}
        batchId={summaryData?.batchId}
        notSM={!summaryData?.isSM}
      />
      <ResultTable data={summaryData?.resultData} />
      <ButtonList reports={pdfURLS} />
      <br />
      {/* <IframeList urls={pdfURLS} /> */}
      <ResponseMessage status={status} />
      {pdfURLS.length > 0 && (
        <ZipButton
          name={name}
          batch={searchText}
          urls={pdfURLS}
          summary={summaryData}
        />
      )}
      {pdfURLS.length > 0 && (
        <ComboButton
          name={name}
          batch={searchText}
          urls={pdfURLS}
          summary={summaryData}
        />
      )}
      <br />
      <br />
      <br />
      {summaryData?.ccURL && (
        <div>
          <div>
            Scan or click to see the{" "}
            <a target="_blank" href={summaryData.ccURL} rel="noreferrer">
              Confident Cannabis report
            </a>{" "}
            for this sample:
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a target="_blank" href={summaryData.ccURL} rel="noreferrer">
              <QRCodeSVG value={summaryData.ccURL} />
            </a>
          </div>
        </div>
      )}
    </>
  );
};
